import React from "react";
import ReactDOM from "react-dom/client";
import { hydrateRoot, createRoot } from "react-dom/client";
import "./index.css";
import "../src/style-css/style.css";
import "../src/style-css/responsive-style.css";
import "../src/style-css/grk-seo-pages.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import store from "./app/store";
import { Provider } from "react-redux";
import ScrollToTop from "./layout/blanklayout/scroll-top/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

let persistor = persistStore(store);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <ScrollToTop />
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
